var _circle, _g, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInterestBondsCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Interest and bonds") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#6B3FA0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#FFFFFF",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.3,
    cy: 5.3,
    r: 1.6,
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.7,
    cy: 10.7,
    r: 1.6,
    strokeWidth: 1.15
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3 4.4L4.7 11.6",
    strokeWidth: 1.4
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.85,
    fill: "none",
    stroke: "#000",
    strokeOpacity: 0.12,
    strokeWidth: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterestBondsCircle);
export default __webpack_public_path__ + "static/media/interest-bonds-circle.9adaa4617ade3578ea92142b4d612196.svg";
export { ForwardRef as ReactComponent };